/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';

export class RoutingSolutionListVoModel extends JSONable {
  uuid: string | undefined = undefined;
  packagesNumber: string | undefined = undefined;
  offerRequestUuid: string | undefined = undefined;
  shipmentRequestUuid: string | undefined = undefined;
  pickupLocation: string | undefined = undefined;
  deliveryLocation: string | undefined = undefined;
  pickupDateTime: DateTimeWithTimezoneModel | undefined = undefined;
  deliveryDateTime: DateTimeWithTimezoneModel | undefined = undefined;
  vehicleTypeValue: string | undefined = undefined;
  licensePlate: string | undefined = undefined;
  details: string | undefined = undefined;
  costValue: number | undefined = undefined;
  currency: string | undefined = undefined;
}
